import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/HomeView.vue";
import plainLayout from "@/views/layout/plainLayout.vue";
import sidebarLayout from "@/views/layout/sidebarLayout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/wxlogin",
    name: "布局0",
    component: () => import("@/views/WxLogin.vue"),
  },
  {
    path: "/test",
    name: "测试",
    component: () => import("@/views/test.vue"),
  },
  {
    path: "/",
    name: "布局1",
    redirect: "/home",
    component: plainLayout,
    children: [
      {
        path: "home",
        name: "首页",
        component: HomeView,
      },
      {
        path: "userPrivacy2",
        name: "隐私政策",
        component: () => import("@/views/userPrivacy2.vue"),
      },
      {
        path: "userPrivacy3",
        name: "用户协议",
        component: () => import("@/views/userPrivacy3.vue"),
      },
      {
        path: "clockinDetail",
        name: "学习打卡详情",
        component: () => import("@/views/study/clockInDetail.vue"),
      },
      {
        path: "courseDetail",
        name: "财富专栏详情",
        component: () => import("@/views/wealth/courseDetail.vue"),
      },
      {
        path: "courseInfo",
        name: "财富专栏文章详情",
        component: () => import("@/views/wealth/courseInfo.vue"),
      },
      {
        path: "stock",
        name: "股票",
        component: () => import("@/views/invest/stockTable.vue"),
      },
      {
        path: "emotiontrend",
        name: "情绪趋势",
        component: () => import("@/views/invest/emotionTrend.vue"),
      },
      {
        path: "qa",
        name: "讨论区详情",
        component: () => import("@/views/study/qa.vue"),
      },

      {
        path: "article",
        name: "文章详情",
        component: () => import("@/views/study/article.vue"),
      },
      {
        path: "answer",
        name: "回答详情",
        component: () => import("@/views/study/answer.vue"),
      },
    ],
  },
  {
    path: "/aichat",
    name: "AI诊股",
    component: () => import("@/views/AiChatView.vue"),
  },
  {
    path: "/in",
    name: "布局2",
    component: sidebarLayout,
    children: [
      {
        path: "clockin",
        name: "学习打卡",
        component: () => import("@/views/study/clockIn.vue"),
      },

      {
        path: "wealthcolumn",
        name: "财富专栏",
        component: () => import("@/views/wealth/wcolumn.vue"),
      },
      {
        path: "discussion",
        name: "讨论区",
        component: () => import("@/views/study/discussion.vue"),
      },
      {
        path: "investtool",
        name: "投资工具",
        component: () => import("@/views/invest/tool.vue"),
      },
      {
        path: "me/knowledgebase",
        name: "知识题库",
        component: () => import("@/views/knowledge/base.vue"),
      },
      {
        path: "me/scoremanage",
        name: "积分管理",
        component: () => import("@/views/score/manage.vue"),
      },
      {
        path: "me/scoremanage/points",
        name: "积分明细",
        component: () => import("@/views/score/sourcePoints.vue"),
      },
      {
        path: "me/dreamtool",
        name: "梦想工具",
        component: () => import("@/views/dream/tool.vue"),
      },
      {
        path: "me/set",
        name: "设置",
        component: () => import("@/views/set/index.vue"),
      },
      {
        path: "me/dreamtool/everyday",
        name: "每日账单",
        component: () => import("@/views/dream/everyday.vue"),
      },
      {
        path: "discussion/more",
        name: "聊天室详情",
        component: () => import("@/views/study/more.vue"),
      },
      {
        path: "me/dreamtool/succ",
        name: "成功日记",
        component: () => import("@/views/dream/succ.vue"),
      },
      {
        path: "me/set",
        name: "设置",
        component: () => import("@/views/set/index.vue"),
      },
      {
        path: "me/privacy",
        name: "用户协议",
        component: () => import("@/views/set/privacy.vue"),
      },
      {
        path: "me/userPrivacy",
        name: "隐私协议",
        component: () => import("@/views/set/userPrivacy.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
